import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const imvReportApi = createApi({
  baseQuery,
  reducerPath: 'imvReportApi',
  endpoints: builder => ({
    getimvReportData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.ImvReport.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}&application_section=CONDUCT&application_module_section=IMV%20REPORT
          `,
        method: 'GET'
      })
    }),
    createImvReportData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvReport.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=IMV%20REPORT`,
        method: 'POST',
        body: data
      })
    }),

    updateImvReportData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvReport.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=IMV%20REPORT`,
        method: 'PUT',
        body: data
      })
    }),

    getAllImvReportData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, from = -1, size = -1 }) => {
        return {
          url: `${formatString(
            endPoints.ImvReport.getAll
          )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}&application_section=CONDUCT&application_module_section=IMV%20REPORT&${
            from > -1 ? `from=${from}` : ''
          }${size > -1 ? `&size=${size}` : ''}`,
          method: 'POST',
          body: data
        };
      }
    }),
    sendForReview: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.ImvReport.sendForReview,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}&application_section=CONDUCT&application_module_section=IMV%20REPORT`,
        method: 'PUT',
        body: data
      })
    }),
    updateSignData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.ImvReport.sign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}&application_section=CONDUCT&application_module_section=IMV%20REPORT`,
        method: 'PUT',
        body: data
      })
    }),
    publishImvReportData: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        data,
        publish_doc_version,
        monitoring_visit_id,
        update,
        is_published,
        application
      }) => ({
        url: `${formatString(
          endPoints.ImvReport.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&update=${update}&is_published=${is_published}&application=${application}&application_section=CONDUCT&application_module_section=IMV%20REPORT`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useLazyGetimvReportDataQuery,
  useUpdateImvReportDataMutation,
  useCreateImvReportDataMutation,
  useGetAllImvReportDataMutation,
  useSendForReviewMutation,
  useUpdateSignDataMutation,
  usePublishImvReportDataMutation
} = imvReportApi;
